import React, {Component} from 'react';
import withAuthorization from '../../Authentication/withAuthorization';
import FilesIDIndex from "./FilesIDIndex";

class FilesIDAuthIndex extends Component {
    render() {
        return(
            <FilesIDIndex/>
        )
    }
}

const authCondition = (authUser) => !!authUser;

export default withAuthorization(authCondition)(FilesIDAuthIndex);
